import { call, put, takeLatest } from 'redux-saga/effects';
import { feedbackActions } from '../actions/feedback';
import * as api from '../api/feedback';
const { feedbackRequest, feedbackRequestSucceeded, feedbackRequestFailed } = feedbackActions;
export const feedback = [
    takeLatest(feedbackRequest.toString(), genWithPromise(api.requestFeedback, feedbackRequestSucceeded, feedbackRequestFailed)),
];
function genWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.error(exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
